<template>
    <div>
        <Head title="Види риболовлі без місця"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('f-types.index')"
            >
                Види риболовлі без місця
            </Link>
            <span class="text-indigo-400 font-medium">/</span> Новий вид
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <select-input v-model="form.lake_id" :error="form.errors.lake_id" class="pb-8 pr-6 w-full"
                                      label="Озеро">
                            <option :value="null"/>
                            <option v-for="lake in lakes" :key="lake.id" :value="lake.id">{{ lake.name }}</option>
                        </select-input>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ціна"/>
                        <text-input v-model="form.day_limit" :error="form.errors.day_limit" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ліміт на день"/>
                        <textarea-input v-model="form.short_description" :error="form.errors.short_description"
                                        class="pb-8 pr-6 w-full" label="Короткий опис"/>
                        <div class="pb-8 pr-6 w-full">
                            <label class="form-label" for="description">Опис</label>
                            <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                      id="description" class="description"/>
                        </div>

                        <drag-and-drop
                            v-model="form.images"
                            :error="form.errors.images"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            type="file"
                            accept="image/*"
                            label="Зображення"
                        />
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити тариф
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import DragAndDrop from '@/Shared/DragAndDrop'
import TextareaInput from '@/Shared/TextareaInput'
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import CKEditor from "@ckeditor/ckeditor5-vue"

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        ckeditor: CKEditor.component
    },
    props: {
        lakes: Array,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                name: '',
                description: '',
                short_description: '',
                day_limit: '',
                price: '',
                lake_id: null,
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('f-types.store'))
        },
    },
}
</script>

<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 500px;
}

.description {
    width: 100%;
    min-width: 100%;
}
</style>
